import MoveAndRotate from "./moveAndRotate";
import AnimationPlayer from "../animation/animationPlayer";

class MoveGroup extends MoveAndRotate {
    groupName;

    constructor(props) {
        super(props);
        this.groupName = props.groupName;
    }

    async stop() {
        this.cancelPendingMoveStepWait();
        const group = GroupData.getGroupByName(this.groupName);
        if (!group) return;
        changePerformMoveOnGroup(true);
        AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.GROUP, group.id);
        changePerformMoveOnGroup(false);
    }

    async execute() {
        const group = GroupData.getGroupByName(this.groupName);
        if (!group) return;
        changePerformMoveOnGroup(true);
        try {
            AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.GROUP, group.id);

            for (let i = 0; i < this.moveSteps.length; i++) {
                const volumeFinalMatrix = this.getComposedMatrix(i);
                const pivot = this.getPivot(i);
                const animateTime = this.getAnimateTime(i);
                const animateMovement = animateTime > 0;

                moveGroup(this.groupName, volumeFinalMatrix, animateMovement, animateTime, !!this.transitionValues, false, pivot);

                if (animateMovement && i < this.moveSteps.length - 1) {
                    if (await this._waitMoveStep(animateTime + 20)) {
                        return;
                    }
                }
            }
        } finally {
            changePerformMoveOnGroup(false);
        }
    }
}

export default MoveGroup;
